import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import Pricing from '../components/sections/Pricing';
import Contact from '../components/sections/Contact';
import ContactModal from '../components/ContactModal';

export default function TarifasPage() {
  const [showContactModal, setShowContactModal] = useState(false);

  const openContactModal = () => setShowContactModal(true);
  const closeContactModal = () => setShowContactModal(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1 }
    );
    document.querySelectorAll('.reveal').forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <>
      <Helmet>
        <title>Tarifas | Inerva Psicología</title>
        <meta
          name="description"
          content="Tarifas y precios de las sesiones de psicología online en Inerva. Consulta nuestras opciones y bonos disponibles."
        />
        <link rel="canonical" href="https://www.inervapsicologia.es/tarifas" />
      </Helmet>

      <Header />

      <main>
        <div className="reveal pt-32 lg:pt-40"><Pricing onContactClick={openContactModal} /></div>
        <Contact onContactClick={openContactModal} />
      </main>

      <Footer />

      <ContactModal show={showContactModal} handleClose={closeContactModal} />
    </>
  );
}
